import { render, staticRenderFns } from "./FormulaSidebar.vue?vue&type=template&id=1d841538&scoped=true"
import script from "./FormulaSidebar.vue?vue&type=script&lang=js"
export * from "./FormulaSidebar.vue?vue&type=script&lang=js"
import style0 from "./FormulaSidebar.vue?vue&type=style&index=0&id=1d841538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d841538",
  null
  
)

export default component.exports